import "./App.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import Navbar from "./layouts/navbar";
import Footer from "./layouts/footer";
import ServicesPage from "./pages/services";
import ServiceDetailsPage from "./pages/service-details";
import PartsAndSuppliesPage from "./pages/PartsAndSuppliesPage";
import AboutUsPage from "./pages/aboutus";
import TopNav from "./layouts/top-nav";
import ContactUs from "./pages/contactus";

function App() {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <TopNav/>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/parts-and-supplies" element={<PartsAndSuppliesPage />} />
          <Route path="/aboutus" element={<AboutUsPage />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/services/:slug" element={<ServiceDetailsPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </React.StrictMode>
  );
}

export default App;
